import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'
import { FormFeedback, FormGroup } from 'reactstrap'

import MESSAGES from 'core/data-model/constants/validation-messages'
import { SidebarMenu } from 'quick-quote/components'
import { getSelectedDisplayProductCode } from 'quick-quote/product-selection/selectors'

export const BenefitIllustration = ({
  sections,
  menus,
  isBlockedEnteringESub,
  className,
  selectedDisplayProductCode,
}) => {
  if (!selectedDisplayProductCode) {
    return <Redirect to="/" push />
  }
  return (
    <div id="benefit-illustration" className={className || ''}>
      <div className="content">
        {sections.map((section, i) => (
          <section.component key={`benefit-illustration-section-${i}`} {...section.props} />
        ))}

        {isBlockedEnteringESub ? (
          <FormGroup className="has-warning">
            <FormFeedback className={'eligibility-message attached-icon'}>
              <div>{MESSAGES.RULE_ENTER_ESUB_PREREQUISITE}</div>
            </FormFeedback>
          </FormGroup>
        ) : null}
      </div>
      <SidebarMenu mainMenu={menus} />
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    selectedDisplayProductCode: getSelectedDisplayProductCode(state),
  }
}

export default connect(mapStateToProps, () => ({}))(BenefitIllustration)
